import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from "../../environments/environment";

@Injectable({
	providedIn: 'root'
})
export class ResolutionsService {
	baseURL = environment.baseAPIURL;

	constructor( private readonly http  : HttpClient) { }

	getResolutions(eventId) {
		return this.http.get(`${this.baseURL}/aetHistory/getEventDetailsResolutions/${eventId}`, { responseType: 'json' }
		)
			.pipe(catchError(this.handleError));
	}
	
	
	private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}
}
